import { useState } from 'react';
import { BookOpen } from 'lucide-react';
import FenetreTexteSupport from './FenetreTexteSupport';

/**
 * Le texte d'une question de compréhension de l'écrit, en haut d'une fenêtre de modification (11/10/2026) :
 * son titre et « Lire le texte », qui l'ouvre par-dessus. On ne corrige pas une question de lecture sans
 * son texte. `support` : { id, titre, pages }.
 */
const LigneTexteLecture = ({ support }) => {
  const [ouvert, setOuvert] = useState(false);
  return (
    <div className="mb-4 flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-100 text-sm text-blue-800">
      <BookOpen size={15} className="shrink-0" />
      <span className="flex-1 min-w-0 truncate">
        Texte de cette question : <b>{support.titre}</b>
      </span>
      <button
        type="button"
        onClick={() => setOuvert(true)}
        className="shrink-0 px-2.5 py-1 rounded-md bg-white border border-blue-200 text-xs font-semibold text-blue-700 hover:bg-blue-100 transition"
      >
        Lire le texte
      </button>
      {ouvert ? <FenetreTexteSupport support={support} onClose={() => setOuvert(false)} /> : null}
    </div>
  );
};

export default LigneTexteLecture;
